import { httpClient } from "@api/http";
import type { PaginationMeta } from "@maeiz/core";

export interface NotificationDto {
    id: string;
    title: string;
    message: string;
    type: string;
    data: Record<string, unknown>;
    url: string | null;
    readAt: string | null;
    createdAt: string;
}

export interface NotificationsListResponse {
    message: string;
    notifications: NotificationDto[];
    unreadCount: number;
    pagination: PaginationMeta;
}

export interface UnreadCountResponse {
    message: string;
    unreadCount: number;
}

export const notificationsApi = {
    list: (params?: { page?: number; perPage?: number; status?: "read" | "unread" }) =>
        httpClient.get<NotificationsListResponse>("/owner/notification/list", { params }),

    unreadCount: () => httpClient.get<UnreadCountResponse>("/owner/notification/unread-count"),

    markRead: (id: string) =>
        httpClient.patch<{ message: string; notification: NotificationDto }>(
            `/owner/notification/${id}/read`
        ),

    markAllRead: () =>
        httpClient.post<{ message: string; unreadCount: number }>("/owner/notification/mark-all-read"),

    delete: (id: string) => httpClient.delete<{ message: string }>(`/owner/notification/${id}`),
};
